import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { DeleteMedia, GetAllMedia, AddMedia } from '../services/mediaservice';

function MediaList() {
    const [data, setData] = useState([]);
    const location = useLocation();
    const { successMessage } = location.state || {};
    let navigate = useNavigate();

    useEffect(() => {
        const response = fillData();
        toast(successMessage);
    }, []);

    const fillData = async () => {
        try {
            const mediaList = await GetAllMedia();
            const jsonMediaList = JSON.parse(mediaList);
            setData(jsonMediaList);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const handleDelete = async (mediaId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this media?");
        if (isConfirmed) {
            DeleteMedia(mediaId);
            const response = await fillData();
            toast("Media deleted successfully!");
        }
    };

    return (
        <>
            <div class="row">
                <div class="col-md-12 grid-margin">
                    <div class="row">
                        <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                            <h3 class="font-weight-bold">Media</h3>
                            {/* <h6 class="font-weight-normal mb-0">All systems are running smoothly! You have <span class="text-primary">3 unread alerts!</span></h6> */}
                        </div>
                        <div class="col-12 col-xl-4">
                            <div class="justify-content-end d-flex">
                                <div class="dropdown flex-md-grow-1 flex-xl-grow-0">
                                    <Link to="/media/add" className='nav-link'>
                                        <button type="submit" class="btn btn-primary me-2">New Media</button>
                                    </Link>
                                    {/* <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuDate2">
                                        <a class="dropdown-item" href="#">January - March</a>
                                        <a class="dropdown-item" href="#">March - June</a>
                                        <a class="dropdown-item" href="#">June - August</a>
                                        <a class="dropdown-item" href="#">August - November</a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-md-12 grid-margin transparent">
                    <div class="row">
                        {
                            data?.map((item) => (
                                <div class="col-md-2 mb-4 stretch-card transparent">
                                    <div class="card card-dark-blue">
                                        <div class="card-body media-card">
                                            <img className='media-tile' src={item.mediapath} title={item.name} />
                                            <i
                                                className="mdi mdi-delete mdi-big font20 pointer delete-item"
                                                title="Delete media"
                                                onClick={() => handleDelete(item.pk)}
                                            ></i>
                                            <div className="media-item-wrapper">
                                                <i
                                                    className="mdi mdi-delete mdi-big font20 pointer media-info-icon"
                                                    title="Show media details"
                                                ></i>

                                                <div className="media-info">
                                                    <div>Pk: {item.pk}</div>
                                                    <div className="font-weight-bold">Name: {item.name}</div>
                                                    <div>File Name: {item.filename}</div>
                                                    <div>File Type: {item.filetype}</div>
                                                    <div>File Ext: {item.fileext}</div>
                                                    <div>Added On: {item.addedon}</div>
                                                    <div>Updated On: {item.updatedon}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div >
            </div >
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}

export default MediaList;
